<template>
    <div class="flexbox sidenav" :style="{width: sideNavShow? '90px': '18px'}">
        <el-drawer
        v-model="sideNavShow"
        direction="ltr" 
        :modal='false'
        :with-header="false"
        :show-close='false'
        size="90px"
        modal-class="slnav">
            <div class="flexbox">
                <el-menu default-active="1-4-1" class="el-menu-vertical-demo" :collapse="true" @select="navSelect">
                    <el-submenu index="1">
                        <template #title>
                        <!-- <i class="el-icon-chat-dot-round"></i> -->
                 <img src="../../assets/img/icon/msg_white.svg" >

                        <p>客户服务</p>
                        </template>
                        <el-menu-item index="pop" @click="popShow('ZX')">我要咨询</el-menu-item>
                        <el-menu-item index="pop" @click="popShow('TS')">我要投诉</el-menu-item>
                        <el-menu-item index="MyQuestion">我的问题</el-menu-item>
                    </el-submenu>
                    <el-submenu index="3">
                        <template #title>
                            <!-- <i class="el-icon-document"></i> -->
                 <img src="../../assets/img/icon/order.svg" >

                            <p>我的订单</p>
                        </template>
                        <el-menu-item index="MyOrder-0">全部订单</el-menu-item>
                        <el-menu-item index="MyOrder-5">待发货</el-menu-item>
                        <el-menu-item index="MyOrder-6">待收货</el-menu-item>
                        <el-menu-item index="MyOrder-7">已完成</el-menu-item>
                    </el-submenu>
                    <el-submenu index="2">
                        <template #title>
                            <!-- <i class="el-icon-user"></i> -->
                 <img src="../../assets/img/icon/user.svg" >

                            <p>个人中心</p>
                        </template>
                        <el-menu-item index="PersonalCenter">客户画像</el-menu-item>
                        <el-menu-item index="MyCollection">我的收藏</el-menu-item>
                    </el-submenu>
                </el-menu>
                <div class="sidenavSw flexbox" @click="sideNavShow = !sideNavShow">
                    <i class="el-icon-arrow-right" v-if="!sideNavShow"></i>
                    <i class="el-icon-arrow-left" v-if="sideNavShow"></i>
                </div>
            </div>
        </el-drawer>
        
        <div class="sidenavSw flexbox" @click="sideNavShow = !sideNavShow" v-if="!sideNavShow">
            <i class="el-icon-arrow-right" v-if="!sideNavShow"></i>
            <i class="el-icon-arrow-left" v-if="sideNavShow"></i>
        </div>
    </div>   
    <el-dialog
        :title="formQTypeText"
        v-model="formQPop"
        width="650px"
        destroy-on-close
        :close-on-click-modal="false"
        :close-on-press-escape='false'
        :append-to-body="true">
            <CustomerService :formQType="formQType" :formQ="formQ" @formQHide="formQHide" :groupId="picgid"></CustomerService>
    </el-dialog>
</template>

<script>
    import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from 'vue'
    import { useRouter } from 'vue-router'
    import CustomerService from '@/components/customerservice/CustomerService'

    export default {
        name: 'SideNav',
        components: {
            CustomerService
        },
        setup() {
            let router = useRouter()
            let { proxy } = getCurrentInstance()
            let pageData = reactive({
                userInfo: {},
                sideNavShow: false
            })
            // ZX 咨询 TS 投诉
            let formQType = ref('ZX')
            let formQTypeText = ref('我要咨询')
            let formQPop = ref(false)
            let picgid = ref('')
            let formQ = ref({
                code: '',
                customer: '',
                phone: '',
                linkman: '',
                salesman: '',
                theme: '',
                desc: '',
                annex: '',
                item: []
            })
            // 获取问题编码
            let getProblemCode = (type) => {
                let data = {
                    postType: 'loadSub',	
                    type: type, // 咨询：ZX 投诉:TS	
                    source: 'customer'	
                }
                proxy.$axios.postReq('/meide/REST/ProblemCloseSub', data)
                .then(res => {
                    if(res.success == 'true') {
                        formQ.value.code = res.problemCode
                        formQ.value.customer = res.customerShortName
                        formQ.value.phone = pageData.userInfo.MOBILE
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            let navSelect = (key, keyPath) => {
                if(key == 'pop') {
                    if(!localStorage.getItem('userInfo')) {
                        router.push('/login')
                        return
                    }else {
                        
                    }
                }else if(key.indexOf('-') != -1) {
                    let keyarr = key.split('-')
                    router.push({name: keyarr[0], params:{tab: keyarr[1]}})
                }else {
                    router.push({name: key})
                }
            }
            let popShow = (type) => {
                if(type == 'ZX') {
                    getProblemCode('ZX')
                    formQType.value = 'ZX'
                    formQTypeText.value = '我要咨询'
                    
                }else if(type == 'TS') {
                    getProblemCode('TS')
                    formQType.value = 'TS'
                    formQTypeText.value = '我要投诉'
                }  
                formQPop.value = true
                for(let key in formQ.value) {
                    formQ.value[key] = ''
                }
                formQ.value.item = []
            }
            let formQHide = (show) => {
                formQPop.value = show
            }
            onBeforeMount(() => {
                if(localStorage.getItem('userInfo')) {
                    pageData.userInfo = JSON.parse(localStorage.getItem('userInfo'))
                }else {

                }
            })
            return {
                ...toRefs(pageData),
                navSelect,
                formQPop,
                formQType,
                formQTypeText,
                formQ,
                popShow,
                formQHide,
                getProblemCode,
                picgid
            }
        }
    }
</script>

<style scoped lang="scss">
    .sidenav {
        position: fixed;
        top: 0px;
        left: 0px;
        z-index: 99999;
        height: 100vh;
        overflow: hidden;
        background: none;
        ::v-deep(.el-overlay) {
            position: absolute;
        }
        ::v-deep(.slnav) {
            position: absolute !important;
            width: 70px;
            background: none;
            .el-drawer {
                background: none;
            }
            .sidenavSw {
                width: 18px;
                height: 200px;
                position: relative;
                /* border: 1px solid #ccc; */
                border-radius: 0 7px 7px 0;
                justify-content: center;
                border-left: none;
                background: rgb(53, 53, 53, 0.3);
                i {
                    color: #fff;
                }
            }
        }
    }
    .el-menu {
        background: none;
        border: none;
        width: 70px;
        height: 100vh;
        background: rgb(53, 53, 53);
        ::v-deep(.el-submenu) {
            width: 100%;
        }
        ::v-deep(.el-submenu__title) {
            padding: 20px 0;
            height: auto;
            white-space: normal;
            line-height: 15px;
            border-bottom: 1px solid #999;
            &:hover {
                background: #F42434;
            }
        }
        i {
            color: #fff;
        }
        p {
            color: #fff;
            width: 30px;
            font-size: 12px;
            margin-top: 5px;
        }
    }
    .sidenavSw {
        width: 18px;
        height: 200px;
        position: relative;
        /* border: 1px solid #ccc; */
        border-radius: 0 7px 7px 0;
        justify-content: center;
        border-left: none;
        background: rgb(53, 53, 53, 0.3);
        i {
            color: #fff;
        }
    }
    .popbox {
        position: fixed;
        z-index: 99999;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background:rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        .popcon {
            width: 580px;
            background: #fff;
            h3 {
                background: rgba(242, 242, 242, 1);
                font-weight: bold;
                padding: 15px 20px;
                font-size: 16px;
                color: #666;
                margin-bottom: 15px;
                span {
                    float: right;
                    font-weight: bolder;
                    font-size: 20px;
                    margin-top: -5px;
                    cursor: pointer;
                }
            }
            ::v-deep(.el-form ){
                padding: 0 20px;
                .el-input--small .el-input__inner {
                    width: 165px;
                }
                .longinput .el-input--small .el-input__inner, .longinput .el-textarea__inner {
                   width: 400px;
               }
               .block {
                   width: 100%;
                   text-align: right;
               }
            }
        }
    }
</style>